module.exports = __webpack_public_path__ + "files/12e84737ffac946e74dfcfaa4d64c988.png";